/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Spaces_Integrations_TabInputs */



/**
* | output |
* | --- |
* | "Spaces & Integrations" |
*
* @param {Admin_Settings_Spaces_Integrations_TabInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_settings_spaces_integrations_tab = /** @type {((inputs?: Admin_Settings_Spaces_Integrations_TabInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Spaces_Integrations_TabInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Spaces & Integrationen")
	return /** @type {LocalizedString} */ ("Spaces & Integrations")
});